import z from 'zod';

/**
 * Why a Lead was marked `lost` / `unqualified` / `dead`. Stored on
 * `Lead.lostReason` so analytics can surface "top reasons we lose
 * deals" without text-mining the timeline.
 *
 * - `price`              — pricing didn't fit their budget.
 * - `competitor`         — chose another vendor.
 * - `no_response`        — went silent after initial contact.
 * - `not_a_fit`          — outside our ICP / not the right product.
 * - `timing`             — interested but "not now".
 * - `bad_data`           — wrong number / fake submission.
 * - `duplicate`          — already an existing customer / open lead.
 * - `other`              — free-form note required.
 */
export const leadLostReasonCodeSchema = z.enum([
  'price',
  'competitor',
  'no_response',
  'not_a_fit',
  'timing',
  'bad_data',
  'duplicate',
  'other',
]);
export type LeadLostReasonCode = z.infer<typeof leadLostReasonCodeSchema>;

export const leadLostReasonSchema = z.object({
  code: leadLostReasonCodeSchema,
  /** Optional free-text elaboration, required when `code === 'other'`. */
  note: z.string().optional(),
});
export type LeadLostReason = z.infer<typeof leadLostReasonSchema>;
